<script setup lang="ts">
import {IconAdd} from "@iconify-prerendered/vue-carbon"
import BankCard from "../components/BankCard.vue";
import {getRouteXAccountsCardOrder} from "../views/Auth/accounts/card/OrderCard.vue";
import {RouterLink} from "vue-router";
</script>

<template>
  <div class="flex gap-6">
    <BankCard :card-uuid="'123123'"/>

    <RouterLink
      :to="getRouteXAccountsCardOrder()"
      class="w-[384px] h-[242px] border-2 border-dashed border-[var(--m-primary-base)] rounded-lg flex flex-col items-center justify-center gap-2 text-[var(--m-primary-base)] hover:bg-[var(--m-blue-2)] transition-colors cursor-pointer"
    >
      <IconAdd class="w-6 h-6"/>
      <span class="font-medium">Add New Card</span>
    </RouterLink>
  </div>
</template>

<style scoped lang="scss">

</style>